export default "__VITE_ASSET__D0rOXWU7__"